import { Injectable } from '@angular/core';
import { SpaceBuilder } from '../builders/space-builder';
import { AuthenticatedApiService } from './authenticated-api.service';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class SpaceApiService {
    constructor(authenticatedApi) {
        this.authenticatedApi = authenticatedApi;
    }
    list(id_parking) {
        return this.authenticatedApi.get(`/adminlot/list_spaces/${id_parking}`).toPromise().then(response => {
            return response.spaces.map(data => SpaceBuilder.buildSpace(data));
        });
    }
    create(spaces_to_create) {
        return this.authenticatedApi.post('/adminlot/spaces', JSON.stringify(spaces_to_create)).toPromise().then(response => response);
    }
    edit(space) {
        return this.authenticatedApi.put('/adminlot/spaces', JSON.stringify(space)).toPromise().then(response => response);
    }
    move(idLot, oldSpaceNumber, newSpaceNumber) {
        return this.authenticatedApi.put(`/adminlot/move_reservation/${idLot}/${oldSpaceNumber}/${newSpaceNumber}`).toPromise().then(response => response);
    }
}
SpaceApiService.ɵfac = function SpaceApiService_Factory(t) { return new (t || SpaceApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
SpaceApiService.ɵprov = i0.ɵɵdefineInjectable({ token: SpaceApiService, factory: SpaceApiService.ɵfac, providedIn: 'root' });
(function () { i0.ɵsetClassMetadata(SpaceApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=space-api.service.js.map